export class AssignCdsCC {
  id: number;
  account_id: string;
  account_name: string;
  client_id: string;
  client_secret: string;
}
